import { Card, Divider, Row } from 'antd'
import { FormInstance } from 'antd/lib'

import { useLocales } from 'src/locales'

import { useStyles } from '../styles'

import { CaseSymptomsCard } from './CaseSymptomsCard'
import { GastroIntenstinalSymptomsCard } from './GastroIntenstinalSymptomsCard'
import { GeneralSymptomsCard } from './GeneralSymptomsCard'
import { HospitalizationSymptomsCard } from './HospitalizationSymptomsCard'
import { NeurologicalSymptomsCard } from './NeurologicalSymptomsCard'
import { OcularSymptomsCard } from './OcularSymptomsCard'
import { OtherSymptomsCard } from './OtherSymptomsCard'
import { PainsSymptomsCard } from './PainsSymptomsCard'
import { RespiratorySymptomsCard } from './RespiratorySymptomsCard'
import { SkinAndMucousSymptomsCard } from './SkinAndMucousSymptomsCard'
import { UrinarySymptomsCard } from './UrinarySymptomsCard'
import { VaccineSymptomsCard } from './VaccineSymptomsCard'

type Props = {
  form: FormInstance
}

export const EpidemiologySymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  return (
    <Card title={t('epidemiology.symptoms_title')}>
      <Row gutter={[24, 24]}>
        <GeneralSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <SkinAndMucousSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <NeurologicalSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <OcularSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <RespiratorySymptomsCard form={form} />

        <Divider className={styles.divider} />

        <GastroIntenstinalSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <UrinarySymptomsCard form={form} />

        <Divider className={styles.divider} />

        <PainsSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <OtherSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <HospitalizationSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <VaccineSymptomsCard form={form} />

        <Divider className={styles.divider} />

        <CaseSymptomsCard />
      </Row>
    </Card>
  )
}
